import { mapToolLists, ToolList } from "./ToolList";

export interface ToolTypeList {
    id?: number;
    category_id?: number;
    type_name?: string;
    path?: string | null;
    status?: 1 | 0;
    tool_count?: number;
    tools?: ToolList[];
}

// to single object maping
export const mapToolTypeList = (data:any): ToolTypeList => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: ToolTypeList ={
        id: data.id,
        category_id: data.category_id,
        type_name: data.type_name,
        path: data.path,
        status: data.status,
        tool_count:data.tool_count,
        tools:mapToolLists(data.tools)
    }
    return res;
}

// maping list objects
export const mapToolTypeLists = (data:any[]): ToolTypeList[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapToolTypeList);
}